import { useReward } from '@/contexts/reward-context';
import { useEffect, useRef, useState } from 'react';
import { Reward, RewardScene, RewardType, UpdateEventProgress } from '@/types';
import { CloseIcon } from '../svg-icons';
import { RewardModalWrapper } from '@/components/reward-modal-wrapper';

export const SignInSpinPopup = () => {
	const buttonRef = useRef<HTMLButtonElement>(null);

	const {
		labels,
		planInfo,
		setRewardScene,
		setCanSignin,
		updateEventProgress,
		setPlanInfo,
		onClose
	} = useReward();

	const [isAnimating, setIsAnimating] = useState<boolean>(false);
	const [spinResult, setSpinResult] = useState<number>(0);

	useEffect(() => {
		if (planInfo?.CanSignIn === false) {
			setRewardScene(RewardScene.SignInResult);
		}
	}, []);

	const spin = () => {
		if (buttonRef.current) {
			buttonRef.current.disabled = true;
		}

		const randomNum = Math.floor(Math.random() * 6) + 1;

		signIn();

		setIsAnimating(true);
		setSpinResult(randomNum);

		setTimeout(() => {
			setRewardScene(RewardScene.SignInResult);
		}, 3500);
	}

	const signIn = () => {
		const signInIndex = planInfo?.Rewards.findIndex((rewardData: Reward): boolean => rewardData.RewardType === RewardType.SignIn) as number;
		const signInRewardId = planInfo?.Rewards?.[signInIndex].RewardId;

		if (updateEventProgress && signInRewardId) {
			updateEventProgress(signInRewardId).then((updatedProgress: UpdateEventProgress) => {

				if (updatedProgress.IsLevelUpNotification) {
					setRewardScene(RewardScene.LevelupPopup);
				}

				if (setCanSignin) {
					setCanSignin(updatedProgress.CanSignin ?? false);
				}

				planInfo.Rewards[signInIndex] = updatedProgress.Rewards;

				if (setPlanInfo) {
					setPlanInfo({
						...planInfo,
						CurrentExp: updatedProgress.CurrentExp,
						CanSignIn: updatedProgress.CanSignin ?? false,
						VipLevel: updatedProgress.VipLevel,
						SabaCoin: updatedProgress.SabaCoin
					});
				}
			});
		}
	}

	return (
		<RewardModalWrapper>
			<div className="reward-modal-close">
				<div 
					className="reward-modal-close__btn"
					onClick={onClose}
				>
					<CloseIcon />
				</div>
			</div>
			<div className="reward-spin" data-result={spinResult}>
				<div className="reward-spin__container">
					<div className="reward-spin__head">
						<div className="reward-spin__star" />
						<div className="reward-spin__title" />
						<div className="reward-spin__subtitle">{labels?.lbl_RPWinning}</div>
					</div>
					<div className="reward-spin__turntable">
						<div className="reward-spin__round">
							<div className="reward-spin__round-center" />
						</div>
						<div className="reward-spin__round-down" />
					</div>
					<div className="reward-spin__footer">
						<button
							ref={buttonRef}
							className="reward-btn-3d"
							type="button"
							data-animate={isAnimating}
							style={{ display: 'flex' }}
							onClick={spin}
						>
							<span className="reward-btn-3d__text">{labels?.lbl_RPClickEarnCoins}</span>
							<div className="reward-btn-3d__bg" />
						</button>
					</div>
				</div>
				<div className="reward-spin__spotlight" />
			</div>
		</RewardModalWrapper>
	);
}